import { Theme } from "@mui/material";

// The chrome shared by the risk module's nivo charts (tooltip container + axis/grid theme), extracted so the
// charts read as one family and a restyle is a single edit instead of one per chart.
export const riskChartGridColor = "#E0E0EC";

export const riskChartTheme = (theme: Theme) => ({
    text: {
        fill: theme.palette.primary.dark,
        fontSize: 13,
    },
    grid: {
        line: {
            stroke: riskChartGridColor,
        },
    },
});

// The tooltip container only; padding and font weight stay with the caller (single-value tooltips are bold
// one-liners, the distribution tooltip is a multi-line block).
export const riskChartTooltipContainerSx = (theme: Theme) => ({
    backgroundColor: theme.palette.background.paper,
    border: `1px solid ${riskChartGridColor}`,
    borderRadius: "4px",
    boxShadow: theme.shadows[2],
    color: theme.palette.primary.dark,
    fontSize: 13,
});
